import { Component, EventEmitter, Injector, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FileDto } from '../../../base-types';
import { FieldType } from '../../../field-type';
import { GridConsumerComponent } from '../../../grids/grid-consumer.component';
import { GridSettings } from '../../../grids/grid-settings';

@Component({
  templateUrl: './lov-dialog.component.html'
})
export class LovDialogComponent extends GridConsumerComponent {

  imgUrl
  @Output() confirmation: EventEmitter<any> = new EventEmitter<any>();


  constructor(
    //@Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<LovDialogComponent>,
    protected _injector: Injector) 
  {
    super(_injector);
  }

  confirm = (imgUrl) => {
    this.confirmation.emit(imgUrl)
    this.dialogRef.close({ out: imgUrl })
  }




















  /** @override */
  async ngOnInit() {
    await super.init()
  }

  /** @override */
  protected async _initColumnsHook() {
    return {
      name:{label: 'Name', type: FieldType.STRING, filterable: true, sortable: true},
      age: {label: 'Age', type: FieldType.INTEGER, filterable: true, sortable: true, width: '120px'},
      birthDate: {label: 'Birth Date', type: FieldType.DATE},
      shiftStart: {label: 'Shift Start', type: FieldType.TIME},
      language: {label: 'Language', type: FieldType.MULTI_OPTION, width: '200px', aggregate:true},
      gender: {label: 'Gender', type: FieldType.OPTION}
    }
  }

  /** @override */
  protected async _initSettingsHook(): Promise<GridSettings> {
    return {
      mode: 'client',
      size: 10,
      columnsSettings: null//buildFormFieldOptions()
    }
  }

  /** @override */
  protected async _setDatasourceHook() {
    // qui ci sarebbe la chiamata al servizio rest
    let reloadedItems=[]
    const rows=10
    for (let index = 0; index < rows; index++) {
      // reloadedItems.push(newRandomSubject())
    }
    
    return reloadedItems.map(el=>el/*toForm(el)*/)
  }

  /** @override */
  protected async _setRowCountHook(): Promise<number> {
    throw new Error("Method not implemented.");
  }

  /** @override */
  protected async _appendRowsToDatasourceHook(lastId: number): Promise<{ [key: string]: number | string | boolean | (string | number)[] | File | File[] }[]> { 
    throw new Error("Method not implemented.");
  }
}